module.exports = __webpack_public_path__ + "static/img/home-Illustration.34e48edb.png";